'use client';

import { rem } from '../../../../utils/units-converters/rem.mjs';
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';

function spacingResolver(value, theme) {
  if (typeof value === "number") {
    return rem(value);
  }

  if (typeof value === "string") {
    var mod = value.replace("-", "");

    if (!(mod in theme.spacing)) {
      return rem(value);
    }

    var variable = "--mantine-spacing-".concat(mod);
    return value.startsWith("-") ? "calc(var(".concat(variable, ") * -1)") : "var(".concat(variable, ")");
  }

  return value;
}

export { spacingResolver };